import { css } from "styled-components";
import { StyledText } from "../../components/Text/Text";
/** @class PaginationItemMixin */

/** @method */

export var PaginationItemMixin = function PaginationItemMixin() {
  return "\n    display: block;\n    margin: 0 2px;\n";
}; // The readout is the "Page x of x" label that appears on smaller screens

export var PaginationReadoutItemMixin = /*#__PURE__*/css(["& > ", "{text-align:center;display:inline-block;}"], StyledText);